<template>
  <div class="cursor" :class="{animate}">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1475 25.4727L18.0105 24.4697L19.6255 23.6307L17.0575 18.8147H21.3895L10.0105 7.40671V23.4217L13.3265 20.2007L16.1475 25.4727Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4308 23.9996L18.1958 23.0586L15.4215 17.857H19.025L11 9.814V21.002L13.5298 18.5599L16.4308 23.9996Z" fill="black"/>
      </g>
      <defs>
        <filter id="filter0_d" x="8" y="6" width="16" height="23" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4049 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
      </defs>
    </svg>
  </div>

</template>

<script>
export default {
  props: {
    animate: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/mixins";

@mixin start {
  @include transform(translateX(10vw) translateY(-30vh));
}

@mixin end {
  @include transform(translateX(0) translateY(0));
}

.cursor {
  position: absolute;
  width: 32px;
  height: 32px;
  left: 50%;
  margin-left: -16px;
  bottom: 15px;
  @include start;
  @include animation(fade-in 1.8s);

  &.animate {
    @include animation(move 3s forwards);
    @include css3-prefix(animation-timing-function, ease-out);
  }
}

@include keyframes(move) {
  0% {
    @include start;
  }

  100% {
    @include end;
  }
}

@include keyframes(fade-in) {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
